export const suppliers = [
  {
    id: 'sup_hostinger',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    legalName: 'Hostinger Brasil Ltda',
    fantasyName: 'Hostinger',
    document: '11.222.333/0001-44',
    stateRegistration: 'ISENTO',
    municipalRegistration: '1234567',
    email: 'suporte@hostinger.com.br',
    phone: '1130001000',
    mobile: '11987654321',
    contactName: 'Suporte Comercial',
    contactEmail: 'comercial@hostinger.com.br',
    contactPhone: '11987654321',
    zipCode: '04571-010',
    street: 'Av. Eng. Luís Carlos Berrini',
    number: '105',
    complement: 'Sala 301',
    neighborhood: 'Cidade Monções',
    city: 'São Paulo',
    state: 'SP',
    notes: 'Cobrança recorrente de hospedagem e domínio.',
    category: 'Infraestrutura',
    status: 'Ativo',
    totalPaid: 1240.5,
    openAmount: 89.9,
  },
  {
    id: 'sup_google',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    legalName: 'Google Brasil Internet Ltda',
    fantasyName: 'Google',
    document: '06.990.590/0001-23',
    stateRegistration: 'ISENTO',
    municipalRegistration: '',
    email: 'billing@google.com',
    phone: '1130002000',
    mobile: '',
    contactName: 'Billing Google Workspace',
    contactEmail: 'billing@google.com',
    contactPhone: '1130002000',
    zipCode: '04538-133',
    street: 'Av. Brigadeiro Faria Lima',
    number: '3477',
    complement: 'Torre Sul',
    neighborhood: 'Itaim Bibi',
    city: 'São Paulo',
    state: 'SP',
    notes: 'Assinatura Google Workspace.',
    category: 'Software',
    status: 'Ativo',
    totalPaid: 864,
    openAmount: 72,
  },
  {
    id: 'sup_contabilidade',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    legalName: 'Contabilidade Exata Ltda',
    fantasyName: 'Contabilidade Exata',
    document: '22.333.444/0001-55',
    stateRegistration: '10.20.30.405',
    municipalRegistration: '5566778',
    email: 'atendimento@contabilidadeexata.com.br',
    phone: '1144556677',
    mobile: '11998877665',
    contactName: 'Fernanda Costa',
    contactEmail: 'fernanda@contabilidadeexata.com.br',
    contactPhone: '11998877665',
    zipCode: '01305-100',
    street: 'Rua Augusta',
    number: '890',
    complement: 'Conj. 52',
    neighborhood: 'Consolação',
    city: 'São Paulo',
    state: 'SP',
    notes: 'Honorários mensais e obrigações acessórias.',
    category: 'Administrativo',
    status: 'Ativo',
    totalPaid: 5400,
    openAmount: 450,
  },
  {
    id: 'sup_microsoft',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    legalName: 'Microsoft Informática Ltda',
    fantasyName: 'Microsoft 365',
    document: '04.711.011/0001-68',
    stateRegistration: 'ISENTO',
    municipalRegistration: '',
    email: 'faturamento@microsoft.com',
    phone: '1130003000',
    mobile: '',
    contactName: 'Conta Microsoft 365',
    contactEmail: 'faturamento@microsoft.com',
    contactPhone: '1130003000',
    zipCode: '04578-000',
    street: 'Av. Nações Unidas',
    number: '12901',
    complement: 'Torre Norte',
    neighborhood: 'Brooklin',
    city: 'São Paulo',
    state: 'SP',
    notes: '',
    category: 'Software',
    status: 'Ativo',
    totalPaid: 1980,
    openAmount: 165,
  },
  {
    id: 'sup_aws',
    organizationId: 'org_3la_labs',
    personType: 'PJ',
    legalName: 'Amazon AWS Serviços Brasil Ltda',
    fantasyName: 'AWS',
    document: '15.436.940/0001-03',
    stateRegistration: 'ISENTO',
    municipalRegistration: '',
    email: 'aws-brasil@amazon.com',
    phone: '1130004000',
    mobile: '',
    contactName: 'Account Manager AWS',
    contactEmail: 'aws-brasil@amazon.com',
    contactPhone: '1130004000',
    zipCode: '04543-011',
    street: 'Av. Presidente Juscelino Kubitschek',
    number: '2041',
    complement: 'Torre D',
    neighborhood: 'Vila Nova Conceição',
    city: 'São Paulo',
    state: 'SP',
    notes: 'Infraestrutura cloud — faturamento em USD convertido.',
    category: 'Infraestrutura',
    status: 'Ativo',
    totalPaid: 8650.4,
    openAmount: 1280.3,
  },
];
